import script from "./USDCPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./USDCPayment.vue?vue&type=script&setup=true&lang=js"

import "./USDCPayment.vue?vue&type=style&index=0&id=58748e33&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58748e33"]])

export default __exports__